import creatingRiskNotes from "../../helpTutorials/creatingRiskNotes.mp4";
import creatingClients from "../../helpTutorials/creatingClients.mp4";
import welcome from "../../helpTutorials/welcome.mp4";

const videoMap = {
    welcome,
    creatingRiskNotes,
    creatingClients,
};

const VideoPlayer = ({ videoUrl }) => {
    const selectedVideo = videoMap[videoUrl];
    if (!selectedVideo) return <p className="sub-title">Video not found</p>;

    return (
        <div className="video-wrapper">
            <video controls style={{ width: "100%", maxWidth: "1080px", height: "auto", borderRadius: "10px", objectFit: "contain" }}>
                <source src={selectedVideo} type="video/mp4" />
            </video>
        </div>
    );
};


export default VideoPlayer;

